/**
 * Injects the The Trade Desk base script into the head.
 *
 * @param isEnabled Whether The Trade Desk base script is enabled.
 * @returns The The Trade Desk base script object.
 */
export function injectTheTradeDeskBase({
  isEnabled,
}: {
  isEnabled: boolean
}) {
  if (!isEnabled) {
    return
  }

  return {
    key: 'the-trade-desk-base',
    type: 'text/javascript' as const,
    src: 'https://js.adsrvr.org/up_loader.1.1.0.js',
  }
}

/**
 * Injects The Trade Desk Script into the head.
 *
 * @param isEnabled Whether The Trade Desk script is enabled.
 * @param advertiserId The advertiser ID.
 * @param uPixelId The uPixel ID.
 * @returns The The Trade Desk script object.
 */
export function injectTheTradeDesk({
  isEnabled,
  advertiserId,
  uPixelId,
}: {
  isEnabled: boolean
  advertiserId: string
  uPixelId: string
}) {
  if (!isEnabled) {
    return
  }

  return {
    key: 'the-trade-desk',
    type: 'text/javascript' as const,
    innerHTML: injectTheTradeDeskScript({ advertiserId, uPixelId }),
  }
}

/**
 * Generates and returns the actual script content for The Trade Desk to be
 * injected.
 *
 * @param advertiserId The advertiser ID.
 * @param uPixelId The uPixel ID.
 * @returns The The Trade Desk script content.
 */
function injectTheTradeDeskScript({
  advertiserId,
  uPixelId,
}: {
  advertiserId: string
  uPixelId: string
}) {
  return `
    ttd_dom_ready( function() {
      if (typeof TTDUniversalPixelApi === 'function') {
        var universalPixelApi = new TTDUniversalPixelApi();
        universalPixelApi.init("${advertiserId}", ["${uPixelId}"], "https://insight.adsrvr.org/track/up");
      }
    });
  `
}
